import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import './prop-types/alert.types';
import { AlertsGrid } from './components/alerts-grid/';
import style from './style.module.less';
import ModalPortal from '../../modal-portal';

const messages = defineMessages({
  modalTitle: {
    description: 'orderAlertsModal.title',
    defaultMessage: 'Alerts',
    id: '/SPk/3',
  },
});

/**
 * @param {object} props
 * @param {AlertPropType[]} props.alerts
 * @param {(isCancel?: boolean) => void} props.onClose
 * @returns {JSX.Element}
 */
export const OrderAlertsModal = ({ alerts, onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style['order-alerts-modal']}>
        <ModalHeader>
          <FormattedMessage {...messages.modalTitle} />
        </ModalHeader>
        <ModalBody className={style['order-alerts-modal-body']}>
          <AlertsGrid alerts={alerts} closeModal={onClose} />
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};
